import React from 'react'
import SignUpPage from '../Login/SignUpModal'

import styles from './SignUp.module.css'

const SignUp = ({ isModal = false }) => (
  <div>
    {!isModal && <img alt="Tiiny Host" src="/assets/logo.png" className={styles.logo} />}

    <div className={styles.signUpBox}>
      <SignUpPage isLoginPage={true} />
    </div>
  </div>
)

export default SignUp
